import {Button, SplitButton} from '@dropbox/dig-components/buttons';
import {Menu} from '@dropbox/dig-components/menu';
import {Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {AddLine} from '@dropbox/dig-icons/assets';
import {Title} from 'components/DSYS/Title';
import {ROUTE_PATHS} from 'constant';
import {t} from 'i18next';
import {useNavigate} from 'react-router';

import {AppsCatalogSearch} from './AppsCatalogSearch';
import {REPLIT_CREATE_URL} from './appUtils';

/** One row: page title, catalog search, and app creation (Ask by default, other paths in the split menu). */
export const AppsCatalogHeader = ({
  onQueryChange,
  query,
}: {
  onQueryChange: (query: string) => void;
  query: string;
}) => {
  const navigate = useNavigate();

  return (
    <Split alignY="center" gap="12">
      <Split.Item width="fill">
        <Title size={24}>{t('apps')}</Title>
      </Split.Item>
      <Split.Item>
        <AppsCatalogSearch query={query} onQueryChange={onQueryChange} />
      </Split.Item>
      <Split.Item>
        <SplitButton
          variant="primary"
          withIconStart={<UIIcon src={AddLine} />}
          onClick={() => navigate(ROUTE_PATHS.APPS_STUDIO)}
          renderMenu={({buttonProps}) => (
            <Menu.Wrapper>
              {({getContentProps, getTriggerProps}) => (
                <>
                  <Button
                    {...buttonProps}
                    {...getTriggerProps()}
                    aria-label={t('apps_create_more_options')}
                  />
                  <Menu.Content {...getContentProps()} placement="bottom-end">
                    <Menu.Segment>
                      <Menu.ActionItem onClick={() => navigate(ROUTE_PATHS.APPS_NEW)}>
                        {t('apps_upload_site')}
                      </Menu.ActionItem>
                      <Menu.LinkItem
                        href={REPLIT_CREATE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('apps_create_in_replit')}
                      </Menu.LinkItem>
                    </Menu.Segment>
                    <Menu.Segment>
                      <Menu.ActionItem onClick={() => navigate(ROUTE_PATHS.APPS_BUILD)}>
                        {t('apps_nova_create')}
                      </Menu.ActionItem>
                    </Menu.Segment>
                  </Menu.Content>
                </>
              )}
            </Menu.Wrapper>
          )}
        >
          {t('apps_create')}
        </SplitButton>
      </Split.Item>
    </Split>
  );
};
